import { authenticatedFetch } from "./apiClient";

const parseError = async (response, fallback) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || data.message || fallback);
  }
  return data;
};

export const normalizeHostname = (value) => {
  let hostname = String(value || "").trim().toLowerCase();
  hostname = hostname.replace(/^https?:\/\//, "");
  hostname = hostname.split("/")[0];
  hostname = hostname.split(":")[0];
  if (hostname.startsWith("www.")) hostname = hostname.slice(4);
  return hostname;
};

export const fetchDomains = async () => {
  const response = await authenticatedFetch("/domains/all");
  return parseError(response, "Failed to fetch websites");
};

export const addDomain = async (hostname) => {
  const response = await authenticatedFetch("/domains/add", {
    method: "POST",
    body: JSON.stringify({
      user_id: "self",
      hostname: normalizeHostname(hostname),
    }),
  });
  return parseError(response, "Failed to add website");
};

export const updateDomain = async (_id, hostname) => {
  const response = await authenticatedFetch("/domains/update", {
    method: "PUT",
    body: JSON.stringify({
      _id,
      domain: {
        user_id: "self",
        hostname: normalizeHostname(hostname),
      },
    }),
  });
  return parseError(response, "Failed to update website");
};

export const deleteDomain = async (_id) => {
  const response = await authenticatedFetch("/domains/delete", {
    method: "DELETE",
    body: JSON.stringify({ _id }),
  });
  return parseError(response, "Failed to delete website");
};
